import { Component } from "react"
import Search from "components/admin/events/search"
import PropTypes from "prop-types"
import EventsList from "./events_list"
import { Paginate } from "components/ui"
import NewEventButton from "components/admin/events/new_event_button"
import SettingsMenu from "components/admin/events/settings_menu"
import EmptyEvents from "components/admin/events/empty_events"
import ChurchCenterSettings from "components/admin/ChurchCenterSettings/ChurchCenterSettings"
import { Icon } from "@planningcenter/tapestry-react"

class Index extends Component {
  constructor(props) {
    super(props)

    this.state = {
      events: props.events,
      searchQuery: null,
      pagination: props.pagination,
      archived: props.archived,
      campusId: props.campusId,
      categoryId: props.categoryId
    }

    this.handleSearch = this.handleSearch.bind(this)
    this.handleSearchResults = this.handleSearchResults.bind(this)
  }

  render() {
    const {
      campuses,
      categories,
      organization,
      churchCenterEventsUrl,
      noLogoUrl,
      isAdmin,
      isOrgAdmin,
      isStripeConnected,
      newEventUrl,
      stripeConnectUrl,
      orgHasEvents,
      ccwEnabled,
      ccaEnabled,
      ccaRegistrationsPublished,
      ccwRegistrationsPublished,
      churchCenterDisabledOrUnpublished,
      churchCenterEventSort,
      subscribedToPublishing,
      overageWarning,
      isActingStaff
    } = this.props

    const { events, pagination, campusId, categoryId, searchQuery: q, archived } = this.state

    return orgHasEvents ? (
      <div>
        <div className="page__header pb-2">
          <div className="d-f@sm ai-c jc-sb w-100%">
            <h1 className="d-n d-b@sm mb-0">Signups</h1>
            <div className="d-f" css={{ gap: "0.5rem" }}>
              {isAdmin && (
                <SettingsMenu isAdmin={isAdmin} churchCenterEventSort={churchCenterEventSort} />
              )}
              <ChurchCenterSettings
                ccaEnabled={ccaEnabled}
                ccwEnabled={ccwEnabled}
                ccaRegistrationsPublished={ccaRegistrationsPublished}
                churchCenterDisabledOrUnpublished={churchCenterDisabledOrUnpublished}
                ccwRegistrationsPublished={ccwRegistrationsPublished}
                churchCenterEventsUrl={churchCenterEventsUrl}
                churchCenterEventSort={churchCenterEventSort}
                subscribedToPublishing={subscribedToPublishing}
                isAdmin={isAdmin}
              />
              {isAdmin && (
                <NewEventButton
                  onNewClick={() => {
                    Turbolinks.visit(`/signups/new`)
                  }}
                />
              )}
            </div>
          </div>
        </div>
        {overageWarning && (
          <div className="overage-banner">
            <Icon size="lg" color="error-dark" name="general.exclamationCircle" />
            <span dangerouslySetInnerHTML={{ __html: overageWarning }} />
          </div>
        )}

        <div className="page__content events-js">
          <div className="pane">
            <Search
              archived={archived}
              organization={organization}
              campuses={campuses}
              campusId={campusId}
              categories={categories}
              categoryId={categoryId}
              churchCenterEventsUrl={churchCenterEventsUrl}
              onSearch={this.handleSearch}
              isAdmin={isAdmin}
              isOrgAdmin={isOrgAdmin}
            />
            <div
              className="pane"
              css={{
                borderLeft: 0,
                borderRight: 0,
                borderBottom: 0,
                "--pane--border-radius": 0,
                "--pane--padding": "11px 12px",
                "--pane--box-shadow-color": "transparent"
              }}
            >
              <h1 className="h3 mb-0">
                {pagination.count} {archived ? "archived" : "active"} signups
              </h1>
            </div>
            <div className="line" />
            <EventsList
              events={events}
              organization={organization}
              noLogoUrl={noLogoUrl}
              isAdmin={isAdmin}
              isOrgAdmin={isOrgAdmin}
              isStripeConnected={isStripeConnected}
              stripeConnectUrl={stripeConnectUrl}
              newEventUrl={newEventUrl}
              orgHasEvents={orgHasEvents}
              ccwEnabled={ccwEnabled}
              ccwRegistrationsPublished={ccwRegistrationsPublished}
              isActingStaff={isActingStaff}
            />
            <div className="pagination-wrapper">
              <Paginate
                pagination={pagination}
                baseParams={{ archived, categoryId, campusId, q }}
                onNavClick={this.handleSearch}
              />
            </div>
          </div>
        </div>
      </div>
    ) : (
      <EmptyEvents
        organization={organization}
        eventsCount={events.length}
        isAdmin={isAdmin}
        isOrgAdmin={isOrgAdmin}
        isStripeConnected={isStripeConnected}
        newEventUrl={newEventUrl}
        stripeConnectUrl={stripeConnectUrl}
        orgHasEvents={orgHasEvents}
      />
    )
  }

  handleSearch({ archived, categoryId, campusId, q, page }) {
    this.setState({ searchQuery: q, campusId, categoryId, archived }, () => {
      const params = []

      if (categoryId) {
        params.push(`categories=${categoryId}`)
      }

      if (campusId) {
        params.push(`campuses=${campusId}`)
      }

      if (q) {
        params.push(`q=${q}`)
      }

      if (archived) {
        params.push("archived=1")
      }

      if (page) {
        params.push(`page=${page}`)
      }

      const paramString = params.join("&")
      const path = "/signups"

      if (paramString) {
        history.replaceState(history.state, "", `${path}?${paramString}`)
      }

      const url = `${path}.json?${paramString}`

      fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      })
        .then(resp => resp.json())
        .then(resp => {
          this.handleSearchResults(q, resp)
        })
    })
  }

  handleSearchResults(query, resp) {
    const { searchQuery } = this.state

    if (query === searchQuery) {
      this.setState({ events: resp["events"], pagination: resp["pagination"] })
    }
  }
}

const { bool, string } = PropTypes

Index.propTypes = {
  archived: bool,
  isAdmin: bool.isRequired,
  isOrgAdmin: bool.isRequired,
  isStripeConnected: bool.isRequired,
  newEventUrl: string.isRequired,
  stripeConnectUrl: string.isRequired,
  churchCenterEventsUrl: string.isRequired,
  ccwEnabled: bool.isRequired,
  ccaEnabled: bool.isRequired,
  ccaRegistrationsPublished: bool.isRequired,
  ccwRegistrationsPublished: bool.isRequired,
  churchCenterEventSort: string,
  churchCenterDisabledOrUnpublished: bool,
  orgHasEvents: bool,
  campusId: string,
  categoryId: string,
  subscribedToPublishing: bool,
  overageWarning: string,
  isActingStaff: bool
}

Index.defaultProps = {
  isAdmin: false,
  isOrgAdmin: false,
  isStripeConnected: false,
  newEventUrl: "",
  stripeConnectUrl: "",
  churchCenterEventsUrl: ""
}

export default Index
